<template>
  <div class="kpi-grid">
    <div class="grid">
      <div v-for="card in cards" :key="card.id" class="col-12 md:col-3">
        <AdminDashboardKpiCard :label="card.label" :value="card.value" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AdminDashboardKpiCard from '@/components/admindashboard/AdminDashboardKpiCard.vue'
import type { AdminDashboardTotals } from '@/utils/adminDashboardUtils'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  totals: AdminDashboardTotals
}>()

const { t } = useI18n()

const cards = computed(() => [
  {
    id: 'companies',
    label: t('adminDashboard.kpi.companies'),
    value: props.totals.companies
  },
  {
    id: 'employees',
    label: t('adminDashboard.kpi.employees'),
    value: props.totals.employees
  },
  {
    id: 'deliveryNotes',
    label: t('adminDashboard.kpi.deliveryNotes'),
    value: props.totals.deliveryNotes
  },
  {
    id: 'aiRequests',
    label: t('adminDashboard.kpi.aiRequests'),
    value: props.totals.aiRequests
  }
])
</script>

<style scoped>
.kpi-grid {
  margin-bottom: 1.5rem;
}
</style>
